import S from "./index205.mjs";
import t from "./index337.mjs";
import E from "./index212.mjs";
function I(d, e) {
  E(1, arguments);
  var r = S(d);
  if (isNaN(r.getTime()))
    throw new RangeError("Invalid time value");
  var o = e != null && e.format ? String(e.format) : "extended", a = e != null && e.representation ? String(e.representation) : "complete";
  if (o !== "extended" && o !== "basic")
    throw new RangeError("format must be 'extended' or 'basic'");
  if (a !== "date" && a !== "time" && a !== "complete")
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  var n = "", i = "", m = o === "extended" ? "-" : "", g = o === "extended" ? ":" : "";
  if (a !== "time") {
    var l = t(r.getDate(), 2), f = t(r.getMonth() + 1, 2), u = t(r.getFullYear(), 4);
    n = "".concat(u).concat(m).concat(f).concat(m).concat(l);
  }
  if (a !== "date") {
    var c = r.getTimezoneOffset();
    if (c !== 0) {
      var v = Math.abs(c), s = t(Math.floor(v / 60), 2), h = t(v % 60, 2), w = c < 0 ? "+" : "-";
      i = "".concat(w).concat(s, ":").concat(h);
    } else
      i = "Z";
    var x = t(r.getHours(), 2), D = t(r.getMinutes(), 2), b = t(r.getSeconds(), 2), p = n === "" ? "" : "T", M = [x, D, b].join(g);
    n = "".concat(n).concat(p).concat(M).concat(i);
  }
  return n;
}
export {
  I as default
};
//# sourceMappingURL=index289.mjs.map
